import { rem } from 'polished';
import styled from 'src/styles/theme';

export const CloseButton = styled.button`
    position: absolute;
    left: unset;
    background: none;
    border: none;
    top: 0;
    right: 0;
    padding: ${rem(6)};
    font-size: ${rem(20)};
    color: ${({ theme }) => theme.colors.black};
    z-index: 999999;
    cursor: pointer;
`;
